type Props = {
  rewardType:
    | "pack"
    | "item"
    | "playerpick"
    | "player"
    | "cosmetic-evo"
    | "event_token_2";
  description: string;
  rewardName?: string;
};

export const SBCRewardDescription = ({
  rewardType,
  description,
  rewardName,
}: Props) => {
  /* A player reward is named and rated by the card itself, so only the set's
     own words are left to print. */
  return rewardType === "player" ? (
    <span className="text-xs text-foreground-muted">{description}</span>
  ) : (
    <div className="flex flex-col h-full ml-1 text-left desktop:ml-0">
      <p className="text-foreground-body font-semibold text-sm desktop:-mt-[6px] desktop:text-base">
        {rewardName}
      </p>
      <span className="mt-2 text-xs text-foreground-muted line-clamp-2">
        {description}
      </span>
    </div>
  );
};
